import axios from "axios";

import {
    getAuthToken
} from "utilities";
import { SuccessResponseInterceptor, ErrorResponseInterceptor } from "./auth-interceptor";
const axiosInstance = axios.create({
    baseURL: process.env.BASE_URL
});

axiosInstance.interceptors.response.use(SuccessResponseInterceptor, ErrorResponseInterceptor);

axiosInstance.interceptors.request.use(_ => {
    _.headers.Authorization = `Bearer ${getAuthToken().authToken}`;
    return _;
});

export default {
    getMarketData: (company_id) => axiosInstance.get(`/company/market-data/${company_id}/update/`),
    createMarketData: (data) => axiosInstance.post("/company/market-data/create/", data),
    updateMarketData: (company_id, data) => axiosInstance.put(`/company/market-data/${company_id}/update/`, data)
};